export const LOCAL_STORAGE: Record<string, string> = {
  AUTO_LOGIN: 'IS_AUTO_LOGIN',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
};
